module.exports = __webpack_public_path__ + "img/araboto-black-webfont.69a38da1.svg";